//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { EventCategoryDisplayItem } from './EventCategoryDisplayItem';
import { EventLocationDisplayItem } from './EventLocationDisplayItem';
import { TransactionDisplayItem } from './TransactionDisplayItem';
import { AttendanceAttachmentDisplayItem } from './AttendanceAttachmentDisplayItem';
import { PackageMinutesDisplayItem } from './PackageMinutesDisplayItem';
import { AttendanceStatus } from './Enums';

export class AttendanceDisplayItem extends ItemBase {
    ID: string | null = null;
    EventID: string | null = null;
    StudentID: string | null = null;
    TeacherID: string | null = null;
    OriginalTeacherID: string | null = null;
    CanCancel: boolean | null = null;
    CanReschedule: boolean | null = null;
    Absent: boolean = false;
    AttendanceStatus: AttendanceStatus = AttendanceStatus.Unrecorded;
    EventDuration: number = 0;
    EventStartDate: string = "1970-01-01T00:00:00";
    EventEndDate: string = "1970-01-01T00:00:00";
    OriginalChargeAmount: number | null = null;
    ParentNote: string | null = null;
    TeacherNote: string | null = null;
    StudentNote: string | null = null;
    GroupNote: string | null = null;
    TeacherGroupNote: string | null = null;
    HasAttachments: boolean = false;
    EmailReminderSent: boolean = false;
    SMSReminderSent: boolean = false;
    Student: StudentNameDisplayItem | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    OriginalTeacher: TeacherNameDisplayItem | null = null;
    EventCategory: EventCategoryDisplayItem | null = null;
    EventLocation: EventLocationDisplayItem | null = null;
    Payment: TransactionDisplayItem | null = null;
    Charge: TransactionDisplayItem | null = null;
    Attachments: AttendanceAttachmentDisplayItem[] = [];
    PackageMinutes: PackageMinutesDisplayItem | null = null;

    constructor(initializer?: Partial<AttendanceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceDisplayItem";
}
